import { render, staticRenderFns } from "./IsolatedTextarea.vue?vue&type=template&id=93ee250e&"
import script from "./IsolatedTextarea.vue?vue&type=script&lang=js&"
export * from "./IsolatedTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports